// src/components/BenefitComponent1.js
import React from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';
import '../styles/scrollAnimations.css';
import './BenefitComponent1.css';

const BenefitComponent1 = ({ imageSrc, iconSrc, headerText, absoluteText, title, description, buttonText, buttonLink }) => {
  const [headerRef, headerVisible] = useScrollAnimation({ threshold: 0.2 });
  const [titleRef, titleVisible] = useScrollAnimation({ threshold: 0.2 });
  const [descriptionRef, descriptionVisible] = useScrollAnimation({ threshold: 0.2 });
  const [buttonRef, buttonVisible] = useScrollAnimation({ threshold: 0.2 });

  return (
    <div className="benefit-wrapper">
      <div className="image-wrapper">
        <img src={imageSrc} alt="Example" className="benefit-image" />
      </div>
      <div className="benefit-component">
        <div className="benefit-container">
          <div 
            ref={headerRef}
            className={`benefit-header scroll-fade-in ${headerVisible ? 'is-visible' : ''}`}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img src={iconSrc} alt="Icon" className="icon" />
              <p className="benefit-header-text">{headerText}</p>
            </div>
            <p className="absolute-text">{absoluteText}</p>
          </div>
          <img src={imageSrc} alt="Example" className="benefit-image-inside" />
          <h2 
            ref={titleRef}
            className={`benefit-title scroll-fade-in scroll-animation-delay-1 ${titleVisible ? 'is-visible' : ''}`}
          >
            {title}
          </h2>
          <p 
            ref={descriptionRef}
            className={`benefit-description scroll-fade-in scroll-animation-delay-2 ${descriptionVisible ? 'is-visible' : ''}`}
          >
            {description}
          </p>
          <a 
            ref={buttonRef}
            href={buttonLink} 
            target="_blank" 
            rel="noreferrer"
            className={`benefit-wrapper-button scroll-fade-in-scale scroll-animation-delay-3 ${buttonVisible ? 'is-visible' : ''}`}
          >
            {buttonText}
          </a>
        </div>
      </div>
    </div>
  );
};

export default BenefitComponent1;
